<div [class]="class" [formGroup]="form" [class.error]="error && error.hasError('*', 'touched')">
  <label *ngIf="!hideLabel" [for]="id" [translate]="key"></label>
  <input
    *ngIf="isInteger; else notInteger"
    [type]="type"
    [id]="id"
    [formControlName]="controlName"
    [placeholder]="(key) ? (key | translate) : ''"
    [minlength]="minlength"
    [maxlength]="maxlength"
    [min]="min"
    appIntegerInput>
  <ng-template #notInteger>
    <input
      [type]="type"
      [id]="id"
      [formControlName]="controlName"
      [placeholder]="(key) ? (key | translate) : ''"
      [minlength]="minlength"
      [maxlength]="maxlength">
  </ng-template>
  <div class="box-error" *ngIf="!hideErrors" [ngxErrors]="controlName" #error="ngxErrors">
    <p class="error" ngxError="required" when="touched" translate>error.required</p>
    <p class="error" ngxError="email" when="touched" translate>error.email</p>
    <p class="error" ngxError="maxlength" when="touched" translate>error.maxlength</p>
    <p class="error" ngxError="minlength" when="touched" translate>error.minlength</p>
    <p class="error" ngxError="pattern" when="touched" translate>error.pattern</p>
    <p class="error" ngxError="match" when="touched" translate>error.password_mismatch</p>
    <p class="error" ngxError="max_value" when="touched" translate [translateParams]="{ value: error.getError('max_value') }">error.max_value</p>
    <p class="error" ngxError="min_value" when="touched" translate [translateParams]="{ value: error.getError('min_value') }">error.min_value</p>
    <p class="error" ngxError="custom" when="touched">{{ error.getError('custom') }}</p>
  </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/input-field/input-field.component.html